import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import UnitTabHeader from './unit/unitTabHeader';
import CoachCourse from '../coachCourse/coachCourse.container';
import IeltsCourse from '../ielts/ieltsCourse.container';
import IWantToFilter from './iWantToFilter/iWantToFilter.container';
import Card from 'react-bootstrap/Card';

const Detail = ({ isCoachCourse, courseType, courseid }) => {
	const [elementFilter, setElementFilter] = useState(
		sessionStorage.getItem('filterApplied') || 'Any',
	);
	useEffect(() => {
		sessionStorage.setItem('filterApplied', elementFilter);
	}, [elementFilter]);

	return (
		<Card>
			<Card.Body className="unitsContainer">
				{isCoachCourse ? (
					<CoachCourse />
				) : (
				<div>
				{courseid == 507 ? (
					<IeltsCourse />
					) : null }
					<Card className="border-0 ">
	{/*					<Card.Header className="unitsHeader">
							<h4>Table of Content</h4>
							{courseType !== 'live' && courseid !== 507 && (
								<IWantToFilter
									setElementFilter={setElementFilter}
									elementFilter={elementFilter}
								/>
							)}
						</Card.Header>*/}
						<Card.Body>
							<UnitTabHeader elementFilter={elementFilter} />
						</Card.Body>
					</Card>
				</div>
				)}
			</Card.Body>
		</Card>
	);
};

const mapStateToProps = (state) => {
	const { isCoachCourse, courseType, courseid } = state.rootReducer.myCourse;
	return {
		isCoachCourse,
		courseType,
		courseid,
	};
};

export default compose(connect(mapStateToProps))(Detail);